export const EPlanCouponDiscountType = {
  Percentage: 0,

  FixedAmount: 1,
}

export type EPlanCouponDiscountType = (typeof EPlanCouponDiscountType)[keyof typeof EPlanCouponDiscountType]
